//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapActions, mapGetters} from "vuex"

export default {

    name: 'HostedPrograms',

    created() {
        this.doHostedBuyer()
    },

    methods: {

        ...mapActions('search', {
            doHostedBuyer: 'doHostedBuyer',
        }),

        openNewTab(url) {
            window.open(url, '_blank')
        },

    },

    computed: {
        ...mapGetters('search', ['hostedBuyer']),
    }

}
